export class Regel {
  regelId: number;
  regelSetId: number;
  type: string;
  waardeRegel: string;
  heralarmeren: boolean;
  filter: boolean;
}
